import { Link } from 'react-router-dom'
import { useOptIn } from '../../hooks/opt-in'

export const DocumentRequiredAlert = () => {
    return (
        <div className="flex items-center justify-center h-screen">
            <div className="border rounded-md shadow-md px-6 py-4">
                <h2 className="text-2xl tracking-tight">
                    Você precisa enviar seus documentos para acessar essa
                    página.
                </h2>
                {/* <p className="text-gray-700 tracking-tight">
                    Clique em  para continuar
                </p> */}
                <div className="flex justify-end mt-6">
                    <Link
                        to="/minhaconta/documentos"
                        className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md"
                    >
                        Enviar documentos
                    </Link>
                </div>
            </div>
        </div>
    )
}
